"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("../util");
const { GET } = util_1.httpMethods;
/**
 * @classdesc Represents the class interfacing history related API-I endpoints
 * @class
 */
class History {
    constructor(api) {
        this.api = api;
    }
    /**
     * Get Node History according to the parameters provided
     *
     * @see {@link https://api-internal.semios.com/4.0.0/docs?#node-histories-get-node-history-get|API Call}
     * @param {Object} args={} - An object containing the arguments accepted by the API
     * @param {?string} args.nodeIdentifier - Optional. The node identifier for history request.
     * @param {?string} args.externalSerialNumber - Optional. The external serial number for history request.
     * @param {?string} args.pseudoIdentifier - Optional. The pseudonode id for history request.
     * @param {?number} args.limit - Optional. The number of latest history records to query.
     * @return {promise} Assets - Returns a Promise that, when fulfilled, will either return an array of data or
     * an error with the problem.
     */
    async getNodeHistory(args) {
        const { nodeIdentifier, externalSerialNumber, pseudoIdentifier, limit } = args || {};
        const methodName = 'getNodeHistory';
        // validate
        const promises = [
            (0, util_1.validateParam)(methodName, 'nodeIdentifier', nodeIdentifier, util_1.ValidationTypes.STRING),
            (0, util_1.validateParam)(methodName, 'externalSerialNumber', externalSerialNumber, util_1.ValidationTypes.STRING),
            (0, util_1.validateParam)(methodName, 'pseudoIdentifier', pseudoIdentifier, util_1.ValidationTypes.STRING),
            (0, util_1.validateParam)(methodName, 'limit', limit, util_1.ValidationTypes.NUMBER),
        ];
        (0, util_1.validateParams)(promises);
        if (!nodeIdentifier && !externalSerialNumber && !pseudoIdentifier) {
            throw (0, util_1.createJSONStringifiedError)((0, util_1.setErrResponse)('Any of the nodeIdentifier, externalSerialNumber, or pseudoIdentifier is not provided.'));
        }
        const route = 'nodes/history';
        const input = {
            query: {
                nodeIdentifier,
                externalSerialNumber,
                pseudoIdentifier,
                limit,
            },
        };
        const formattedInput = (0, util_1.setFormattedInput)(input);
        return this.api.send(GET, route, formattedInput);
    }
}
exports.default = History;
//# sourceMappingURL=history.js.map